<template>
    <v-container>
        <v-row>
            <v-col
                class="text-center mt-4 pa-0"
            >
                <h1>
                Menu
                </h1>
            </v-col>
        </v-row>
        <v-row>
            <Menu/>
        </v-row>
    </v-container>
</template>

<script>
// @ is an alias to /src
import Menu from '@/components/menu/Menu.vue'

export default {
  components: {
    Menu
  }
}
</script>
